// extracted by mini-css-extract-plugin
module.exports = {"area":"Area_area__2ajCu","header":"Area_header__2H8Qk","products":"Area_products__1bXAj"};